import React, { useRef } from "react";
import styles from "./Attachment.module.css";
import { LuUpload } from "react-icons/lu";

const Attachment = ({
  label,
  accept = "*",
  required = false,
  onFileSelect,
}) => {
  const inputRef = useRef();

  const handleChange = (e) => {
    const file = e.target.files[0];
    console.log("File selected:", file); // ✅ DEBUG LOG
    if (file && onFileSelect) {
      onFileSelect(file);
    }
  };

  const triggerUpload = () => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  return (
    <div className={styles.uploadBlock}>
      <label className={styles.inputLabel}>
        {label} {required && <span style={{ color: "black" }}>*</span>}
      </label>

      <div className={styles.uploadCard} onClick={triggerUpload}>
        <div className={styles.uploadLabel}>
          <LuUpload className={styles.uploadIcon} />
          <span className={styles.uploadText}>
            Browse and upload files from device
          </span>
        </div>
        <input
          ref={inputRef}
          type="file"
          accept={accept}
          onChange={handleChange}
          style={{ display: "none" }}
        />
      </div>
    </div>
  );
};

export default Attachment;
